import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Grid, Input, InputLabel, MenuItem, Paper, Select, useTheme } from '@material-ui/core';


import { dataAxureFetch } from '../../../helpers/fetch';
import { useStyles } from '../dashboardStyle';
import { StepChart } from '../../charts/StepChart';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
};

/**
 * Lets get the style and modify it for size 
 * @param {string} point 
 * @param {string} pointsName 
 * @param {string} theme 
 */
const getStyles =(point, pointsName, theme)=>{
    return {
      fontWeight:
        pointsName.indexOf(point) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}

export const StepChartScreen = ({realtime}) => {
    const classes = useStyles();
    const theme = useTheme();

    const uid = useSelector((state) => state.auth.uid);
    const uptws = useSelector((state) => state.auth.ptws);
    const [data, setData] = useState([])
    const [pointsName, setPointsName] = useState("")
    /**
     * Allow to change if real time or not, charge data
     */
    useEffect(() => {
        if (!realtime) {
            return;
        }
        getData();
        let unmounted = false;
        const interval = setInterval(() => {
            if (!unmounted) {
                getData();
                
            }
        }, 60 * 1000);
        return () => {
            if (!realtime) {
                return;
            }
            unmounted = true
            clearInterval(interval);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * To get data from de differents json 
     */
    const getData = async () => {
        const responseTotalPointsActives = await dataAxureFetch({ solicitud: "NomPuntosAlert", idCliente: uid, ptws:uptws }, 'POST');
        if (responseTotalPointsActives !== null) {
            setData(responseTotalPointsActives.pop().nv_alar_hora)
        }else{
            setData([])
        }
    }

    const dataNames = data.map(name=>name.nombre)
    /**
     * Remove repeating elements to put only names 
     * @param {string} value the same element to be removed 
     * @param {number} index number of the element
     * @param {string} self element to be removed 
     * @returns Array without repeating elements 
     */
    const removeRepeatedElement =(value, index, self)=> { 
        return self.indexOf(value) === index;
    }
    
    const pointsElements = dataNames.filter( removeRepeatedElement );
    const filterDataByName= data.filter(data=>data.nombre === pointsName);
    const handleChangeInput = (event) => {
        setPointsName(event.target.value);
    };

    return (
        <>
            <Grid item xs={12} md={12} lg={12}>
                <Grid className={classes.containerSelect}>
                <InputLabel id="name-step">Ultimas Alertas Activas</InputLabel>
                    <Select
                        labelId="names-step"
                        id="multiplestepPoints"
                        value={pointsName}
                        onChange={handleChangeInput}
                        input={<Input />}
                        MenuProps={MenuProps}

                    >
                        <MenuItem value="" disabled>
                            <em>Sin Alertas Recientes</em>
                        </MenuItem>
                        {pointsElements.map((nameAlarm) => (
                            <MenuItem key={nameAlarm} value={nameAlarm} style={getStyles(nameAlarm, pointsName, theme)}>
                                {nameAlarm}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper className={classes.paper}>
                    <StepChart
                        realtime
                        dataChartStep={filterDataByName}
                        namePoint={pointsName}
                    />
                </Paper>
            </Grid>

        </>
    )
}
